export default "__VITE_ASSET__Ddfou0e5__"